<template>
  <CRow class="w-100">
    <CCol v-if="status == 'loading'">
      <!-- //TODO Criar um layout para unificar com recover -->
      <div class="d-flex justify-content-center align-items-center mb-3" style="height: 100%">
        <CSpinner color="custom-color" style="width: 4rem; height: 4rem" />
      </div>
    </CCol>
    <CCol sm="12" v-show="status !== 'loading'" class="w-100">
      <CRow>
        <CCol sm="12">
          <template v-if="message.status">
            <CAlert maxlength="255" :color="message.status" closeButton>
              {{ message.message }}
            </CAlert>
            <h2 class="h1 mb-5" :class="`text-${message.status}`"></h2>
          </template>
        </CCol>
        <CCol sm="12">
          <CForm autocomplete="off" @submit.prevent="submit">
            <h1 class="mb-0">{{ $t('auth.recover.header1.fprgpt-passwprd') }}</h1>
            <p>
              {{ $t('auth.recover.text.help-reset') }}
            </p>
            <CRow class="mt-5">
              <CCol md="5">
                <CInput
                  class="mb-1"
                  :label="$t('auth.recover.input.email')"
                  type="email"
                  v-model.trim="$v.email.$model"
                  :isValid="checkIfValid('email')"
                  :invalidFeedback="'required'"
                  id="validationCode"
                  addLabelClasses="label-custom required"
                  aria-describedby=""
                  :placeholder="$t('auth.recover.input.email-placeholder')"
                  autocomplete="false"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="4">
                <CButton type="submit" :disabled="!isValid || submitted" class="btn btn-primary btn-block font-weight-bold py-3 mt-5">
                  {{ $t('auth.recover.button.reset-password') }}
                </CButton>
              </CCol>
            </CRow>
            <CLink class="mt-3 text-muted d-inline-block" to="/auth/login">{{ $t('auth.recover.link.back') }}</CLink>
          </CForm>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
export default {
  name: 'Recover',
  data() {
    return {
      email: null,
      submitted: false,
      message: {},
    }
  },
  mixins: [validationMixin],
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },
    submit() {
      if (!this.isValid) {
        return
      }

      this.message = []

      const email = this.email

      this.$store
        .dispatch('auth/passwordRecovery', email)
        .then(() => {
          this.message = {
            status: 'success',
            message: this.$t('auth.recover.messages.check-email'),
          }
          sessionStorage.setItem('emailUser', this.email)
        })
        .catch((error) => {
          this.message = {
            status: 'danger',
            message: error.response.data.message,
          }
        })
    },
  },
  computed: {
    isValid() {
      return !this.$v.$invalid
    },
    status() {
      return this.$store.getters['auth/authStatus']
    },
  },
}
</script>

<style></style>
